import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

interface IDeleteScheduleById {
  id: string;
  repeat: boolean;
  event_pid: string;
  update_series: boolean;
}

const deleteScheduleById = ({ id, ...postData }: IDeleteScheduleById) => {
  const newEndpoints = endpoints.scheduling.scheduleById.replace('{id}', id);
  return http().delete(newEndpoints, postData);
};

export function useDeleteScheduleById(options?: any) {
  const queryClient = useQueryClient();

  return useMutation<void, Error, IDeleteScheduleById>({
    mutationFn: deleteScheduleById,
    ...options,
    onSettled: (data: any) => {
      if (data) {
        queryClient.invalidateQueries({ queryKey: ['fetchCalendarView'] });
      }
    },
  });
}
